import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import VacationsComponent from '../components/VacationsComponent'

const mapStateToProps = (state) => {
  return {
    vacations: state.vacations,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VacationsComponent)
